<template>
  <div
    style="min-width:250px;min-height:120px;position:absolute;top:27%;left:45%;z-index:999;text-align: center;background-color: rgba(7,35,59,.9);border: 1px solid rgba(41, 155, 255, .5)"
    v-if="divVisible">
    <i @touchstart="handleClose" @click="handleClose" class="el-icon-close close-btn"></i>
    <div style="margin-top: 15px;display: inline-block">
      <div class="title-line"
           style="background-image: linear-gradient(to right, rgba(15, 61, 104, 1), rgba(41, 155, 255, 1));"></div>
      <div class="title"> {{ deviceInfo.name }}</div>
      <div class="title-line"
           style="background-image: linear-gradient(to right, rgba(41, 155, 255, 1), rgba(15, 61, 104, 1));"></div>
    </div>
    <el-row style="margin-top: 10px;">
      <el-col :span="10" style="text-align: right;padding-right: 5%">
        <img src="../../../assets/images/device/TempHumidity.png" style="margin:10px;">
      </el-col>
      <el-col :span="14" style="text-align: left;">
        <div :key="item.id" v-for="item in historyData">
          <div :style="{color:  '#01EFFD'}">{{
              item.pointName
            }}：{{ item.pointValueName }}
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {getHistoryByDevicePoint} from "@/network/measuring-point-history";

export default {
  name: "DeviceDetailDiv",
  props: ['divVisible', 'deviceInfo'],
  watch: {
    divVisible: {
      handler(val) {
        this.visible = val
      }
    },
    deviceInfo() {
      this.deviceId = this.deviceInfo.id
      this.getPointData();
    }
  },
  data() {
    return {
      visible: false,
      pointCodes: [],
      historyData: [],
      deviceId: this.deviceInfo.id,
    }
  },
  mounted() {
    this.getPointData();
  },
  created() {
    this.$store.dispatch('addIntervalObj', {'getTempData:5000': this.getPointData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getTempData')
  },
  methods: {
    handleClose() {
      this.visible = false
      this.$emit('divClose', this.visible)
    },
    getPointData() {
      getHistoryByDevicePoint({
        deviceId: this.deviceId,
        pointCodes: this.pointCodes
      }).then(res => {
        if (res.code === 0) {
          this.historyData = res.data.filter(item => item.pointName && item.pointName.trim() !== '');
        }
      })
    }
  },
}
</script>

<style scoped>

.title {
  display: inline;
  font-size: 1rem;
  font-weight: bold;
  margin: 5px;
}

.close-btn {
  float: right;
  margin-top: 5px;
  margin-right: 8px;
  font-weight: normal;
  color: #FFFFFF;
}

.close-btn:hover {
  cursor: pointer;
}

.title-line {
  width: 50px;
  height: 2px;
  display: inline-block;
  margin-bottom: 5px;
  border-radius: 15px;
}
</style>
